import { Controller } from "@hotwired/stimulus"
import { baseKit } from "../shared/browserKit"

export default baseKit(({ parseHTML }) => {
  return class StreamMessageController extends Controller {

    static targets = [
      "backtrace",
    ]

    static values = {
      scrollintoview: {
        type: Boolean,
        default: false
      }
    }

    close() {
      this.element.classList.add('hidden')
    }

    connect() {
      if (this.scrollintoviewValue) {
        const offset = 72;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = this.element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }

    backtraceTargetConnected(element) {
      // toggle line clamp
      const activeClass = "line-clamp-5"
      element.title = "Double click to toggle line clamp"
      element.classList.toggle(activeClass)
      element.addEventListener('dblclick', (event) => {
        event.preventDefault()
        event.stopPropagation()
        element.classList.toggle(activeClass)
      })
    }
  }
})
